import { connect } from "react-redux";
import React, { Component, Fragment } from "react";
import { addStepSurvey } from "../../../../redux/actions/surveyActions";
import { Checkbox, Tabs } from "antd";
import _ from "lodash";

const CheckboxGroup = Checkbox.Group;

class RegionalesView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surveySecteurs: [],
      secteurList: this.props.sectorList
    };
  }

  onChange = (checkedValues, a, b, c) => {
    const { regionaleList } = this.props;
    //add sectors to reducer
    let surveyProgress = this.props.surveyProgress;
    surveyProgress.pdcs = surveyProgress.pdcs || [];
    //use pdcs to get survey visibility
    surveyProgress.usePdcs = true;

    //get current sectors ids to compare
    const currentRegionales = surveyProgress.regionales || [];
    const currentRegionalesIds = [];

    let selectRegionales = [];
    //surveyProgress.pdcs = surveyProgress.pdcs || [];

    _.forEach(checkedValues, (value, index) => {
      const regionale = _.find(regionaleList, { label: value });
      if (regionale) {
        selectRegionales.push({
          label: regionale.label
        });
      }
    });

    let zipSecteurs = _.zipObject(["regionales"], [selectRegionales]);
    _.assign(surveyProgress, zipSecteurs);
    this.props.addStepSurvey(surveyProgress);

    for (let i = 0; i < currentRegionales.length; i++) {
      const currentRegionale = currentRegionales[i];
      if (currentRegionale.label) {
        currentRegionalesIds.push(currentRegionale.label);
      }
    }

    //remove pdcs from removed sectors
    if (currentRegionalesIds.length > checkedValues.length) {
      for (let i = 0; i < currentRegionalesIds.length; i++) {
        const currentRegionalesId = currentRegionalesIds[i];
        if (checkedValues.indexOf(currentRegionalesId) === -1) {
          const regionale = _.find(regionaleList, { label: currentRegionalesId });
          if (regionale && regionale.pdcs && regionale.pdcs.length > 0) {
            surveyProgress.pdcs = surveyProgress.pdcs.filter(item => !regionale.pdcs.includes(item));
          }
        }
      }
    } else {
      //add pdcs from removed sectors
      for (let i = 0; i < checkedValues.length; i++) {
        const checkedValue = checkedValues[i];
        if (currentRegionalesIds.indexOf(checkedValue) === -1) {
          console.log(checkedValue);
          console.log("add all pdcs from sector " + checkedValue);
          const regionale = _.find(regionaleList, { label: checkedValue });
          if (regionale && regionale.pdcs && regionale.pdcs.length > 0) {
            //surveyProgress.pdcs = [...surveyProgress.pdcs, ...regionale.pdcs];
            surveyProgress.pdcs = _.union(surveyProgress.pdcs, regionale.pdcs);
            //setTimeout(()=>{this.props.addStepSurvey(surveyProgress);}, 200)
          }
        }
      }
    }

		if(surveyProgress.pdcs.length === 0){
			surveyProgress.usePdcs = false;
		}

    setTimeout(() => {
      this.props.addStepSurvey(surveyProgress);
    }, 300);
  };

  render() {
    const { regionaleList, currentRegionales = [] } = this.props;
    const regionalesChecked = [];

    for (let i = 0; i < currentRegionales.length; i++) {
      const currentRegionale = currentRegionales[i];
      if (currentRegionale.label) {
        regionalesChecked.push(currentRegionale.label);
      }
    }

    return (
      <Fragment>
        <CheckboxGroup onChange={this.onChange} value={regionalesChecked}>
          {regionaleList.map((regionale, index) => {
            let checked = regionalesChecked.indexOf(regionale.label) !== -1;
            return (
              <div
                className={`p-survey-longblock p-mrg-right-s p-mrg-top ${checked ? "selected" : ""}`}
                key={regionale.label}
              >
                <Checkbox value={regionale.label}>
                  <span className={`${checked ? "p-txt-bold p-clr-blck" : ""}`}>{regionale.label}</span>
                </Checkbox>
              </div>
            );
          })}
        </CheckboxGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const surveyProgress = state.survey.surveyManager.surveyProgress || {};
  //retailer
  const models = surveyProgress.model || [];
  let currentModel = models.length > 0 ? models[0] : {};
  const currentRetailerId = currentModel.idRetailer || "";

  const pdcs = state.sectors.pdcs || [];
  const regionaleList = [];
  for (let i = 0; i < pdcs.length; i++) {
    const pdc = pdcs[i];
    if (pdc.retailer_id !== currentRetailerId) {
      continue;
    }
    pdc.regionales = pdc.regionales || [];
    for (let j = 0; j < pdc.regionales.length; j++) {
      const regionale = pdc.regionales[j];
      let regionaleItem = _.find(regionaleList, { label: regionale });

      if (!regionaleItem) {
        regionaleItem = {
          label: regionale,
          pdcs: []
        };
        regionaleList.push(regionaleItem);
      }

      regionaleItem.pdcs = regionaleItem.pdcs || [];

      if (regionaleItem.pdcs.indexOf(pdc.pdc_id) === -1) {
        regionaleItem.pdcs.push(pdc.pdc_id);
      }
    }
  }

  console.log(currentRetailerId, regionaleList);
  return {
    surveyProgress: state.survey.surveyManager.surveyProgress,
    regionaleList: regionaleList
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addStepSurvey: survey => {
      dispatch(addStepSurvey(survey));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegionalesView);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSecteur/RegionalesView.js